import React, { useState, useEffect } from 'react';
import Api from "../../../services/api";
import "../../../assets/css/app/monetization.css";
import { Button, Form, Row, Col, InputGroup, FormControl } from 'react-bootstrap';
import Accordion from "react-bootstrap/Accordion";
import { Tabs } from "antd";

import {
    BarChart,
    Bar,
    LineChart,
    Line,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ComposedChart,
    ResponsiveContainer
} from "recharts";

import DateComponent from "../../../components/datepicker";
import Select2Custom from "../../../components/Select2Custom";


const FilterForm = ({ buttonLabel, onSubmit, startDate, endDate, handleChangeDate, handleChangeCountry, minName, maxName, minValue, maxValue, onChange }) => {
    const [formData, setFormData] = useState({
        playMode: "Chapter Mode",
        level: "Tracking from Events",
        firstOpenFrom: "",
        firstOpenTo: "",
        activeFrom: "",
        activeTo: "",
        country: "United States (US)",
        appVersions: [],
        daysSinceOpenFrom: 0,
        daysSinceOpenTo: 1,
        achievedLevelFrom: 0,
        achievedLevelTo: 1000,
        includeEvent: "",
        userOrigin: "",
        inactiveDays: "",
        adLtvPercent: "",
        adLtvD: "",
        iapLtvPercent: "",
        iapLtvD: ""
    });
    const [activeButton, setActiveButton] = useState('demo');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    const countryOptions = [
        { value: "vn", label: "Vietnam" },
        { value: "us", label: "United States" },
        { value: "jp", label: "Japan" },
        { value: "kr", label: "Korea" },
        { value: "sg", label: "Singapore" },
    ];


    return (
        <form className="" onSubmit={handleSubmit}>
            <Row className="mb-2">
                <Col md={2} className="mb-2">
                    <label htmlFor="exampleFormControlSelect1">Play Mode:</label>
                    <Form.Select
                        value={formData.playMode}
                        className="form-control"
                        onChange={handleChange}
                    >
                        <option value="">All Play Modes</option>
                        <option>Chapter Mode</option>
                        <option>Tower Mode</option>
                        <option>normal</option>
                        <option>unknown</option>
                    </Form.Select>
                </Col>
                <Col md={2} className="mb-2">
                    <label htmlFor="exampleFormControlSelect1">Level:</label>
                    <Form.Select
                        value={formData.playMode}
                        className="form-control"
                        onChange={handleChange}
                    >
                        <option value="">Tracking from Events</option>
                        <option>Hours after first open</option>
                        <option>Days after first open</option>
                    </Form.Select>
                </Col>
                <Col md={2} className="mb-2">
                    <label htmlFor="exampleFormControlSelect1">First Open:</label>
                    <DateComponent
                        startDate={startDate}
                        endDate={endDate}
                        handleChangeDate={handleChangeDate}
                    />
                </Col>
                <Col md={2} className="mb-2">
                    <label htmlFor="exampleFormControlSelect1">Active date:</label>
                    <DateComponent
                        startDate={startDate}
                        endDate={endDate}
                        handleChangeDate={handleChangeDate}
                    />
                </Col>

                <Col md={2} className="mb-2">
                    <label htmlFor="exampleFormControlSelect1">Country:</label>
                    <Select2Custom
                        options={countryOptions}
                        onChange={handleChangeCountry}
                        placeholder="Select"
                        isMulti={true}
                        isValid={null}
                        className=""
                    />
                </Col>
                <Col md={2} className="mb-2">
                    <label htmlFor="exampleFormControlSelect1">A/B Test:</label>
                    <Form.Select
                        value={formData.playMode}
                        className="form-control"
                        onChange={handleChange}
                    >
                        <option value="">A/B Test</option>
                        <option>2000_2001_2002</option>
                        <option>bag expansion_allusers_ARPDAU</option>
                    </Form.Select>
                </Col>
                <Col md={2} className="mb-2">
                    <label htmlFor="exampleFormControlSelect1">App Version:</label>
                    <Select2Custom
                        options={countryOptions}
                        onChange={handleChangeCountry}
                        placeholder="Select"
                        isMulti={true}
                        isValid={null}
                        className=""
                    />
                </Col>
                <Col md={2} className="mb-2">
                    <label htmlFor="exampleFormControlSelect1">Days since first open (D0, D1, ...):</label>
                    <div className="input-container">
                        <div className="min-group">
                            <input type="text" className="input-field" placeholder="Min"/>
                        </div>
                        <div className="separator-group">
                            ~
                        </div>
                        <div className="max-group">
                            <input type="text" className="input-field" placeholder="Max"/>
                        </div>
                    </div>
                </Col>
                <Col md={2} className="mb-2">
                    <label htmlFor="exampleFormControlSelect1">Resource:</label>
                    <Form.Select
                        value={formData.playMode}
                        className="form-control"
                        onChange={handleChange}
                    >
                        <option>diamond</option>
                        <option>gold</option>
                    </Form.Select>
                </Col>
            </Row>
            <div className="ant-divider">
                <span className="ant-divider-inner-text" style={{ marginInlineStart: "0px", marginRight: "16px" }}>
                    <h5 className="ant-typography css-36gkoj">Filter by User Segment</h5>
                </span>
            </div>
            <Row className="mb-2">
                <Col md={2} className="mb-2">
                    <label htmlFor="exampleFormControlSelect1">Users Who Have Achieved Levels:</label>
                    <div className="input-container">
                        <div className="min-group">
                            <input type="text" className="input-field" placeholder="Min"/>
                        </div>
                        <div className="separator-group">
                            ~
                        </div>
                        <div className="max-group">
                            <input type="text" className="input-field" placeholder="Max"/>
                        </div>
                    </div>

                </Col>
                <Col md={3} className="mb-2">
                    <label htmlFor="exampleFormControlSelect1">Users Who Have Events:</label>
                    <div className="d-flex align-content-between input-filter-las-1">
                        <Form.Select
                            value={formData.playMode}
                            className="form-control"
                            onChange={handleChange}
                            style={{ width: "23%" }}
                        >
                            <option>Include</option>
                            <option>Exclude</option>
                        </Form.Select>
                        <Select2Custom
                            options={countryOptions}
                            onChange={handleChangeCountry}
                            placeholder="Select"
                            isMulti={true}
                            isValid={null}
                            className=""
                        />
                    </div>

                </Col>
                <Col md={3} className="mb-2">
                    <label htmlFor="exampleFormControlSelect1">User Origin:</label>
                    <div className="d-flex align-content-between input-filter-las-1">
                        <Form.Select
                            value={formData.playMode}
                            className="form-control"
                            onChange={handleChange}
                            style={{ width: "23%" }}
                        >
                            <option>Include</option>
                            <option>Exclude</option>
                        </Form.Select>
                        <Select2Custom
                            options={countryOptions}
                            onChange={handleChangeCountry}
                            placeholder="Select"
                            isMulti={true}
                            isValid={null}
                            className=""
                        />
                    </div>

                </Col>
                <Col md={2} className="mb-2">
                    <label htmlFor="exampleFormControlSelect1">Users who were inactive in:</label>
                    <div className="input-group mb-3 custom-input">
                        <input type="text" className="form-control" placeholder="Number of days" />
                        <span className="input-group-text">days</span>
                    </div>
                </Col>

                <Col md={3} className="mb-2">
                    <label htmlFor="exampleFormControlSelect1">Filter users by Ad LTV:</label>
                    <div className="d-flex align-content-between input-filter-las-2">
                        <Form.Select
                            value={formData.playMode}
                            className="form-control"
                            onChange={handleChange}
                            style={{ width: "49%", marginRight: "6px" }}
                        >
                            <option>Top</option>
                            <option>Bottom</option>
                        </Form.Select>
                        <div className="input-group mb-3 custom-input">
                            <input type="text" className="form-control" placeholder="" />
                            <span className="input-group-text">%</span>
                        </div>
                        <div style={{ lineHeight:"35px", margin: "0 6px" }}>
                            by
                        </div>
                        <div className="ant-input-number-affix-wrapper iap-ltv">
                            <span className="ant-input-number-prefix">Ad LTV D</span>
                            <div className="ant-input-number input-group">
                                <input
                                    type="number"
                                    min="1"
                                    max="30"
                                    step="1"
                                    className="form-control ant-input-number-input"
                                />
                            </div>
                        </div>
                    </div>
                </Col>

                <Col md={3} className="mb-2">
                    <label htmlFor="exampleFormControlSelect1">Filter users by IAP LTV:</label>
                    <div className="d-flex align-content-between input-filter-las-2">
                        <Form.Select
                            value={formData.playMode}
                            className="form-control"
                            onChange={handleChange}
                            style={{ width: "49%", marginRight: "6px" }}
                        >
                            <option>Top</option>
                            <option>Bottom</option>
                        </Form.Select>
                        <div className="input-group mb-3 custom-input">
                            <input type="text" className="form-control" placeholder="" />
                            <span className="input-group-text">%</span>
                        </div>
                        <div style={{ lineHeight:"35px", margin: "0 6px" }}>
                            by
                        </div>
                        <div className="ant-input-number-affix-wrapper iap-ltv">
                            <span className="ant-input-number-prefix">IAP LTV D</span>
                            <div className="ant-input-number input-group">
                                <input
                                    type="number"
                                    min="1"
                                    max="30"
                                    step="1"
                                    className="form-control ant-input-number-input"
                                />
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row className="mb-2">
                <Col md={1}>
                    <Button variant="primary">{buttonLabel}</Button>
                </Col>
                {
                    buttonLabel !== 'Compare' &&
                    <Col md={2}>
                        <div className="btn-radio-group">
                            <button
                                className={`btn-radio ${activeButton === 'demo' ? 'active' : ''}`}
                                onClick={() => setActiveButton('demo')}
                            >
                                Demo
                            </button>
                            <button
                                className={`btn-radio ${activeButton === 'live' ? 'active' : ''}`}
                                onClick={() => setActiveButton('live')}
                            >
                                Live
                            </button>
                        </div>
                    </Col>
                }
            </Row>
        </form>
    );
};

const generateData = (min, max) => {
    const rateData = [];
    const playTimeData = [];
    const failData = [];
    const failureData = [];
    const adTab1AdLTVData = [];
    const rpm = [];

    for (let i = min; i <= max; i++) {
        rateData.push({
            level: `Lv ${i}`,
            abandonment: Math.floor(Math.random() * 50) + 10, // %
            remain: Math.floor(Math.random() * 60) + 30, // %
        });

        playTimeData.push({
            level: `Lv ${i}`,
            playTime: Math.floor(Math.random() * 1000) + 200, // time
        });

        failData.push({
            level: `Lv ${i}`,
            fails: Math.floor(Math.random() * 500) + 50,
            failUsers: Math.floor(Math.random() * 300) + 20,
        });

        failureData.push({
            level: `Lv ${i}`,
            failureRate: Math.floor(Math.random() * 500) + 50,
        });

        rpm.push({
            level: `Lv ${i}`,
            ecpm: Math.floor(Math.random() * 20) + 10,
        });

        adTab1AdLTVData.push({
            level: `Lv ${i}`,
            bannerAdLTV: Math.floor(Math.random() * 5) + 1,
            interstitialAdLTV: Math.floor(Math.random() * 5) + 1,
            rewardedAdLTV: Math.floor(Math.random() * 5) + 1,
            appOpenAdLTV: Math.floor(Math.random() * 8) + 2,
            MRECAdLTV: Math.floor(Math.random() * 8) + 2,
            rewardedInterstitialAdLTV: Math.floor(Math.random() * 5) + 1,
            nativeAdsAdLTV: Math.floor(Math.random() * 5) + 1,
            audioAdsAdLTV: Math.floor(Math.random() * 5) + 1,
            collapsibleBannerAdLTV: Math.floor(Math.random() * 5) + 1,
            accumulatedLTV: Math.floor(Math.random() * 20) + 10,

        });
    }

    return {
        rate: rateData,
        playTime: playTimeData,
        fails: failData,
        failureData: failureData,
        adTab1AdLTVData: adTab1AdLTVData,
        rpm: rpm,
    };
};
function ResourceAnalyticsApp(){
    const [dataTotal,setDataTotal] = useState([]);
    const [loading, setLoading] = useState(true);
    const [groupBy, setGroupBy] = useState("");
    const [lastEvent, setLastEvent] = useState("");
    const [selectedEvents, setSelectedEvents] = useState([]);

    const [min, setMin] = useState(1);
    const [max, setMax] = useState(50);
    const [step, setStep] = useState(50);
    const runReport = (data) => {
        console.log("Run Report:", data);
    };

    const compareReport = (data) => {
        console.log("Compare:", data);
    };

    const handleLeft = () => {
        if (max === 0 || min > max) return;
        setMin((prev) => Math.max(0, Math.floor(prev / 2)));
        setMax((prev) => Math.max(0, Math.floor(prev / 2)));
    };

    // Cộng theo step mà user nhập
    const handleRight = () => {
        if (max === 0 || min > max) return;
        setMin((prev) => prev + step);
        setMax((prev) => prev + step);
    };

    // Xử lý khi nhập min
    const handleChangeMin = (e) => {
        const val = Math.max(0, parseInt(e.target.value) || 0);
        setMin(val);
    };

    // Xử lý khi nhập max (lưu cả max và step)
    const handleChangeMax = (e) => {
        const val = Math.max(0, parseInt(e.target.value) || 0);
        setMax(val);
        setStep(val);
    };

    const eventOptions = [
        { value: "view_content", label: "View Content" },
        { value: "add_to_cart", label: "Add To Cart" },
        { value: "initiate_checkout", label: "Initiate Checkout" },
        { value: "purchase", label: "Purchase" },
        { value: "app_install", label: "App Install" },
    ];

    const handleEventChange = (selected) => {
        setSelectedEvents(selected || []);
        console.log("Selected events:", selected);
    };

    const disabled = max === 0 || min >= max;

    const { TabPane } = Tabs;

    // chart
    const dataAll = generateData(min, max);

    return (
        <>
        <div className='background-second-dashboard'>
            <section className="main__content-dashbard">
                <div className="container-fluid">
                    <div className='card'>
                        <div className='card-body'>
                            <div className="tab-content" id="nav-tabContent">
                                <div className="tab-pane fade show active" id="nav-home" role="tabpanel"
                                    aria-labelledby="nav-home-tab">
                                    <div className="detail-body">
                                        <div className="overview_content pd-20">
                                            <div className="mt-4">
                                                {/*<LoadingComponent loading={loading} />*/}
                                                <div className="mb-6">
                                                    <FilterForm buttonLabel="Run Report" onSubmit={runReport} />
                                                </div>
                                                <div className="mb-6">
                                                    <Accordion>
                                                        <Accordion.Item eventKey="0">
                                                            <Accordion.Header>Compare with</Accordion.Header>
                                                            <Accordion.Body>
                                                                <FilterForm buttonLabel="Compare" onSubmit={compareReport} />
                                                            </Accordion.Body>
                                                        </Accordion.Item>
                                                    </Accordion>
                                                </div>
                                                <div className="mb-6">
                                                    <div className="d-flex align-items-center">
                                                        <label className="me-2 fw-bold">Level:</label>
                                                        <InputGroup style={{ width: "280px" }}>
                                                            <Button
                                                                variant="outline-secondary"
                                                                onClick={handleLeft}
                                                                disabled={disabled}
                                                            >
                                                                «
                                                            </Button>

                                                            <FormControl
                                                                type="number"
                                                                value={min}
                                                                onChange={handleChangeMin}
                                                            />

                                                            <InputGroup.Text>~</InputGroup.Text>

                                                            <FormControl
                                                                type="number"
                                                                value={max}
                                                                onChange={handleChangeMax}
                                                            />

                                                            <Button
                                                                variant="outline-secondary"
                                                                onClick={handleRight}
                                                                disabled={disabled}
                                                            >
                                                                »
                                                            </Button>
                                                        </InputGroup>
                                                    </div>
                                                </div>
                                                <div className="mb-6">
                                                    <Tabs defaultActiveKey="2" type="line">
                                                        <TabPane tab="Resource" key="1">
                                                            <div className="mb-6">
                                                                <div className="mb-4">
                                                                    <h5>Total Source/Sink</h5>
                                                                </div>
                                                                <div className="mb-4">
                                                                    <ResponsiveContainer width="100%" height={350}>
                                                                        <ComposedChart data={dataAll.rate}>
                                                                            <CartesianGrid strokeDasharray="3 3" />
                                                                            <XAxis dataKey="level" />
                                                                            {/* Trục trái: Abandonment */}
                                                                            <YAxis
                                                                                yAxisId="left"
                                                                                orientation="left"
                                                                                stroke="#8884d8"
                                                                                domain={[0, 100]}
                                                                                // label={{ value: "Abandonment Rate (%)", angle: -90, position: "insideLeft" }}
                                                                            />
                                                                            {/* Trục phải: Remain */}
                                                                            <YAxis
                                                                                yAxisId="right"
                                                                                orientation="right"
                                                                                stroke="#82ca9d"
                                                                                domain={[0, 100]}
                                                                                // label={{ value: "Remain Rate (%)", angle: 90, position: "insideRight" }}
                                                                            />
                                                                            <Tooltip />
                                                                            <Legend />
                                                                            {/* Cột: Abandonment */}
                                                                            <Bar yAxisId="left" dataKey="abandonment" fill="#4285F4" name="Abandonment Rate" />
                                                                            {/* Line: Remain */}
                                                                            <Line yAxisId="right" type="monotone" dataKey="remain" stroke="#FFA600" name="Remain Rate" />
                                                                        </ComposedChart>
                                                                    </ResponsiveContainer>
                                                                </div>
                                                            </div>

                                                            <div className="mb-6">
                                                                <div className="mb-4">
                                                                    <h5>Users Source/Sink</h5>
                                                                </div>
                                                                <div className="mb-4">
                                                                    <ResponsiveContainer width="100%" height={350}>
                                                                        <BarChart data={dataAll.playTime}>
                                                                            <CartesianGrid strokeDasharray="3 3" />
                                                                            <XAxis dataKey="level" />
                                                                            <YAxis />
                                                                            <Tooltip />
                                                                            <Legend />
                                                                            <Bar dataKey="playTime" fill="#4285F4" name="Play Time (minutes)" />
                                                                        </BarChart>
                                                                    </ResponsiveContainer>
                                                                </div>
                                                            </div>
                                                            <div className="mb-6">
                                                                <div className="mb-4">
                                                                    <h5>Balance</h5>
                                                                </div>
                                                                <div className="mb-4">
                                                                    <ResponsiveContainer width="100%" height={350}>
                                                                        <BarChart data={dataAll.playTime}>
                                                                            <CartesianGrid strokeDasharray="3 3" />
                                                                            <XAxis dataKey="level" />
                                                                            <YAxis />
                                                                            <Tooltip />
                                                                            <Legend />
                                                                            <Bar dataKey="playTime" fill="#4285F4" name="Play Time (minutes)" />
                                                                        </BarChart>
                                                                    </ResponsiveContainer>
                                                                </div>
                                                            </div>
                                                        </TabPane>
                                                        <TabPane tab="Booster Usage" key="2">
                                                            <div className="row">
                                                                <div className="d-flex align-items-center mb-4 col-md-2">
                                                                    <label className="me-2" style={{ width: "40%" }}>
                                                                        Group By:
                                                                    </label>
                                                                    <Form.Select
                                                                        className="form-control"
                                                                        value={groupBy}
                                                                        onChange={(e) => setGroupBy(e.target.value)}
                                                                    >
                                                                        <option value="">Select Group By</option>
                                                                        <option value="location">Failure reasons</option>
                                                                        <option value="adnetwork">Number of Fails</option>
                                                                    </Form.Select>
                                                                </div>
                                                                <div className="col-md-1">
                                                                    {groupBy && (
                                                                        <Button
                                                                            variant="primary"
                                                                            className="ms-2"
                                                                            onClick={() => alert(`Applied with ${groupBy}`)}
                                                                        >
                                                                            Apply
                                                                        </Button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="mb-6">
                                                                <div className="mb-4">
                                                                    <h5>Total Booster Usage</h5>
                                                                </div>
                                                                <div className="mb-4">
                                                                    <ResponsiveContainer width="100%" height={400}>
                                                                        <ComposedChart data={dataAll.fails}>
                                                                            <CartesianGrid strokeDasharray="3 3" />
                                                                            <XAxis dataKey="level" />
                                                                            <YAxis yAxisId="left" orientation="left" />
                                                                            <YAxis yAxisId="right" orientation="right" />
                                                                            <Tooltip />
                                                                            <Legend />

                                                                            <Bar yAxisId="left" dataKey="fails" fill="#4285F4" name="Level Fails" />

                                                                            <Line
                                                                                yAxisId="right"
                                                                                type="monotone"
                                                                                dataKey="failUsers"
                                                                                stroke="#FFA600"
                                                                                name="Fail Users"
                                                                            />
                                                                        </ComposedChart>
                                                                    </ResponsiveContainer>
                                                                </div>
                                                            </div>
                                                        </TabPane>
                                                    </Tabs>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
            
        </>
    );
}
export default ResourceAnalyticsApp;